import React, { useState } from 'react'
import { Button, Grid } from '@geist-ui/react'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import PlusSquare from '@geist-ui/react-icons/plusSquare'
import { useAuth0 } from '@auth0/auth0-react'
import Link from 'next/link'
import { Logo } from 'components'

export default function AdminMenu() {
  const { logout } = useAuth0()
  const handleLogout = () => {
    logout({ returnTo: window.location.origin })
  }

  const [dropdownOpen, setDropdownOpen] = useState(false)

  return (
    <>
      <Grid.Container
        xs={0}
        sm={24}
        alignItems="center"
        justify="space-between"
        style={{
          padding: '10px 20px',
          borderBottom: '1px solid rgba(0,0,0,.075)',
          boxShadow: '1px 1px 20px rgba(0,0,0,.05)',
          background: '#fff',
          position: 'fixed',
          top: '0',
          zIndex: '9999',
        }}
      >
        <Grid xs={0} sm={3}>
          <Logo />
        </Grid>

        <Grid sm xs={0} justify="center">
          <Link href="/claims">
            <Button auto width="30%" mx="10px" scale={0.7} type="abort">
              Claims
            </Button>
          </Link>
          <Link href="/enrollments">
            <Button auto width="30%" mx="10px" scale={0.7} type="abort">
              Enrollments
            </Button>
          </Link>
          <Link href="/enrollments/pending-cancellations">
            <Button auto width="30%" mx="10px" scale={0.7} type="abort">
              Pending Cancellations
            </Button>
          </Link>
          <Link href="/customers">
            <Button auto width="30%" mx="10px" scale={0.7} type="abort">
              LWC Customers
            </Button>
          </Link>
        </Grid>

        <Grid>
          <Link href="/enrollments/new">
            <Button
              auto
              width="30%"
              scale={0.7}
              type="abort"
              icon={<PlusSquare />}
              style={{ marginRight: '1rem' }}
            >
              New enrollment
            </Button>
          </Link>
          <Link href="/">
            <Button
              auto
              width="30%"
              scale={0.7}
              type="success"
              icon={<PlusSquare />}
              style={{ marginRight: '1rem' }}
            >
              Create claim
            </Button>
          </Link>
          <Button onClick={handleLogout} auto scale={0.7} type="error">
            Sign out
          </Button>
        </Grid>
      </Grid.Container>

      {/* START MOBILE */}
      <Grid.Container
        xs={24}
        sm={0}
        justify="space-between"
        style={{
          padding: '10px 20px',
          borderBottom: '1px solid rgba(0,0,0,.075)',
          boxShadow: '1px 1px 20px rgba(0,0,0,.05)',
          background: '#fff',
          position: 'fixed',
          top: '0',
          zIndex: '9999',
        }}
      >
        <Grid sm={0}>
          <Logo height="30px" />
        </Grid>

        <Grid sm={0}>
          <DropdownMenu.Root open={dropdownOpen} onOpenChange={setDropdownOpen}>
            <DropdownMenu.Trigger asChild>
              <Button auto type="success-light" scale={0.75}>
                Menu
              </Button>
            </DropdownMenu.Trigger>

            <DropdownMenu.Portal>
              <DropdownMenu.Content
                className="DropdownMenuContent"
                sideOffset={5}
                style={{
                  backgroundColor: 'white',
                  borderRadius: '6px',
                  boxShadow:
                    '0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2)',
                  animationDuration: '400ms',
                  animationTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
                  willChange: 'transform, opacity',
                  zIndex: 10000,
                }}
              >
                <DropdownMenu.Item className="DropdownMenuItem">
                  <Button className="dropdownItem first">
                    <Link href="/" onClick={() => setDropdownOpen(false)}>
                      Create claim
                    </Link>
                  </Button>
                </DropdownMenu.Item>
                <DropdownMenu.Item className="DropdownMenuItem">
                  <Button className="dropdownItem">
                    <Link href="/claims" onClick={() => setDropdownOpen(false)}>
                      View claims
                    </Link>
                  </Button>
                </DropdownMenu.Item>
                <DropdownMenu.Item className="DropdownMenuItem">
                  <Button className="dropdownItem">
                    <Link
                      href="/enrollments"
                      onClick={() => setDropdownOpen(false)}
                    >
                      View enrollments
                    </Link>
                  </Button>
                </DropdownMenu.Item>
                <DropdownMenu.Item className="DropdownMenuItem">
                  <Button className="dropdownItem">
                    <Link
                      href="/enrollments/pending-cancellations"
                      onClick={() => setDropdownOpen(false)}
                    >
                      Pending Cancellations
                    </Link>
                  </Button>
                </DropdownMenu.Item>
                <DropdownMenu.Item className="DropdownMenuItem">
                  <Button className="dropdownItem">
                    <Link
                      href="/customers"
                      onClick={() => setDropdownOpen(false)}
                    >
                      View customers
                    </Link>
                  </Button>
                </DropdownMenu.Item>
                <DropdownMenu.Item className="DropdownMenuItem">
                  <Button className="dropdownItem">
                    <Link
                      href="/enrollments/new"
                      onClick={() => setDropdownOpen(false)}
                    >
                      New enrollment
                    </Link>
                  </Button>
                </DropdownMenu.Item>
                <DropdownMenu.Item className="DropdownMenuItem">
                  <Button
                    type="error"
                    className="dropdownItem error"
                    onClick={handleLogout}
                  >
                    Sign out
                  </Button>
                </DropdownMenu.Item>
              </DropdownMenu.Content>
            </DropdownMenu.Portal>
          </DropdownMenu.Root>
        </Grid>
      </Grid.Container>
      {/* END MOBILE */}
    </>
  )
}
